/*eslint-disable no-unused-vars */
import React, { useCallback, useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  setReportsFilter,
  resetReportsFilter,
  setReportsDataFetching,
  setReportsData,
  setSelectedReports,
  setReportsPagination,
  setIsServerErrorOnList,
  setIsServerDataNotFoundErrorOnList,
} from '../../../../redux/admin/reportsSlice';
import {
  frameColumnsForReportsList,
  arrayBufferToBase64,
} from 'src/Admin/utils/common';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import debounce from 'lodash.debounce';
import ToastMessage from '../../common/ToastMessage';
import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';
import { ToastContainer, toast } from 'react-toastify';

const getFormattedData = (data) => {
  if (data?.ReportDetails?.length > 0) {
    const FORMATTED_DATA = [];
    data.ReportDetails.map((item) => {
      console.log('reportItem', item);
      FORMATTED_DATA.push({
        reportName: item?.reportname,
        reportCategory: item?.module,
        createdDate: item?.createddate,
        status: item?.currentstatus,
        type: item?.reportlocation,
        //reasonOfFailing: undefined,
        createdBy: item?.created_by,
        oid: item?.oid,
        userOid: item?.useroid,
        id: item?.oid,
      });
      return;
    });
    return FORMATTED_DATA;
  }
  return [];
};

const DATE_OPTIONS = [
  {
    label: 'Last 7 Days',
    value: '7',
  },
  {
    label: 'Last 10 Days',
    value: '10',
  },
  {
    label: 'Last 15 Days',
    value: '15',
  },
  {
    label: '1 Month',
    value: '30',
  },
];

const STATUS_OPTIONS = [
  {
    label: 'In Progress',
    value: 'in progress',
  },
  {
    label: 'Completed',
    value: 'completed',
  },
  {
    label: 'Failed',
    value: 'failed',
  },
];

const useReportList = () => {
  const dispatch = useDispatch();

  const { expiry, fileFormat } = useSelector(
    (state) => state?.app?.reportConfig,
  );
  const {
    filters,
    isDataFetching,
    reportsData,
    isServerErrorOnList,
    isServerDataNotFoundErrorOnList,
  } = useSelector((state) => state?.reports);
  const { Oid } = useSelector((state) => state?.user?.userData);
  const [searchText, setSearchText] = useState('');

  const [showModal, setShowModal] = useState(false);
  const handleClose = () => {
    setShowModal(false);
  };

  const columnNames = useMemo(() => {
    return frameColumnsForReportsList();
  }, [getReportListData]);

  const debouncedCall = useCallback(
    debounce(
      (currentVal) => dispatch(setReportsFilter({ searchText: currentVal })),
      800,
    ),
    [],
  );

  const onSearchTextChange = (e) => {
    setSearchText(e.target.value);
    debouncedCall(e.target.value);
  };

  const pageSizeHandler = (pageSize) => {
    dispatch(setReportsPagination({ pageNumber: 1, pageSize: pageSize }));
    getReportListData(false, 1, pageSize);
  };

  const paginationHandler = (page) => {
    dispatch(setReportsPagination({ pageNumber: page }));
    getReportListData(false, page);
  };

  const resetReportFilters = () => {
    setSearchText('');
    dispatch(resetReportsFilter());
    getReportListData(true);
    console.log('Resetting Reports Filters');
  };

  const getReportListData = async (
    isRefresh,
    paginationPageNumber = null,
    paginationPageSize = null,
  ) => {
    dispatch(setIsServerErrorOnList(false));
    dispatch(setIsServerDataNotFoundErrorOnList(false));
    dispatch(setReportsDataFetching(true));
    try {
      console.log(
        'getReportListData Call Get Reports List data API here with these parameter => ',
        filters,
      );
      let filtersEndpointDataURL = '';
      if (filters?.date) {
        filtersEndpointDataURL += `/createddate/${filters?.date?.value}`;
      }
      if (filters?.status) {
        filtersEndpointDataURL += `/currentstatus/${filters?.status?.value}`;
      }
      if (filters?.category) {
        filtersEndpointDataURL += `/module/${filters?.category?.label}`;
      }
      if (filters?.searchText) {
        filtersEndpointDataURL += `/reportname/${filters?.searchText}`;
      }
      const URL =
        APIEndpoints.getAllReportList() +
        (Oid ? Oid : '') +
        (isRefresh ? '' : filtersEndpointDataURL) +
        `/pagenumber/${
          isRefresh
            ? 1
            : paginationPageNumber || reportsData?.pagination?.pageNumber
        }/pagesize/${
          isRefresh
            ? 10
            : paginationPageSize || reportsData?.pagination?.pageSize
        }/sortby/createddate/sortdirection/desc`;
      const response = await axiosInstance.get(URL);
      const formattedData = getFormattedData(response?.data?.Response);
      console.log(
        'getReportListData resp =>',
        response?.data?.Response,
        formattedData,
      );
      if (formattedData?.length === 0) {
        dispatch(setReportsData([]));
        dispatch(setIsServerErrorOnList(true));
        dispatch(setIsServerDataNotFoundErrorOnList(true));
      } else {
        dispatch(setReportsData(formattedData));
      }
      dispatch(
        setReportsPagination({
          totalRecords: response?.data?.Response?.Pagination?.TotalRecords || 0,
        }),
      );
      dispatch(setReportsDataFetching(false));
      return response;
    } catch (error) {
      console.log(error);
      dispatch(setReportsDataFetching(false));
      dispatch(setIsServerErrorOnList(true));
      if (error.toString().includes('404')) {
        dispatch(setIsServerDataNotFoundErrorOnList(true));
        dispatch(setReportsData([]));
      }
    }
  };

  const refreshHandler = () => {
    dispatch(resetReportsFilter());
    getReportListData(true); //When Refreshing, so passing true to call API with initial Filter's DATA.
  };

  const handleSelectionReport = (data) => {
    dispatch(setSelectedReports(data));
  };

  const handleDownloadReport = async (row, fileType) => {
    console.log('Call Download Report API', row);
    try {
      const reportPath = btoa(row.type);
      const extesion = 'XLS';
      const params = reportPath + '/filetype/' + fileType;
      const responseDetails = await axiosInstance.get(
        `${APIEndpoints.getDownloadReport()}${params}`,
        { responseType: 'arraybuffer' },
      );
      //const responseDetails = await axiosInstance.get( `https://roundstone-dev.mphasishealthportal.com/apigw/v1/report/downloadroi/reportpath/L0hvbWUvRTMzNC9yZXN0b25lMzM0L01hc3RlciBGaWxlIE1haW50ZW5hbmNlL3VzZXIwMDEtQ2xpZW50TGlzdC0xNjgxMTEzMTg4MTk2LnJvaTsxMA==/filetype/PDF`, { responseType: 'arraybuffer' } );
      const contentType = responseDetails.headers['content-type'];
      downloadFile(
        row.reportName + '.' + fileType,
        responseDetails.data,
        contentType,
      );
    } catch (err) {
      console.log(err);
    }
  };

  const downloadFile = async (reportName, byte, contentType) => {
    const actualData = arrayBufferToBase64(byte);
    const link = document.createElement('a');
    link.setAttribute('href', `data:${contentType};base64,` + actualData);
    link.setAttribute('download', reportName);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleSendReportsEmail = async () => {
    //#TODO need to call API for Send Email with following Selected Reports
    try {
      const getOIDReports = reportsData?.selectedReports.map(
        (item) => item?.oid,
      );
      for (let index = 0; index < getOIDReports.length; index++) {
        const currentOid = getOIDReports[index];
        const URL =
          APIEndpoints.sendReportsEmail() + currentOid + '/filetype/PDF';
        const response = await axiosInstance.get(URL);
        console.log(
          'Call Send Report API',
          reportsData?.selectedReports,
          response,
        );
      }
      toast.success(
        <ToastMessage
          type="success"
          subTitle="The Report has been sent to your registered email successfully."
        />,
      );
    } catch (error) {
      return;
    }
  };

  const handleDeleteReports = async () => {
    setShowModal(false);
    try {
      const getOIDReports = reportsData?.selectedReports.map(
        (item) => item?.oid,
      );
      for (let index = 0; index < getOIDReports.length; index++) {
        const currentOid = getOIDReports[index];
        const URL = APIEndpoints.deletedSelectedReports() + currentOid;
        const response = await axiosInstance.delete(URL);
        console.log(
          'Call Delete Report API',
          reportsData?.selectedReports,
          response,
        );
      }
      toast.success(
        <ToastMessage
          type="success"
          subTitle={`${
            reportsData?.selectedReports.length > 1
              ? 'The Reports have'
              : 'The Report has'
          } been deleted successfully.`}
        />,
      );
      dispatch(
        setReportsPagination({
          ...reportsData?.pagination,
          pageNumber: 1,
          pageSize: 10,
        }),
      );
      getReportListData(true);
    } catch (error) {
      console.log(error);
      toast.error(
        <ToastMessage
          type="error"
          subTitle="Something went wrong with the request! Failed to delete record."
        />,
      );
    }
  };

  return {
    columnNames,
    refreshHandler,
    DATE_OPTIONS,
    STATUS_OPTIONS,
    resetReportFilters,
    isDataFetching,
    dispatch,
    setReportsFilter,
    filters,
    getReportListData,
    expiry,
    paginationHandler,
    pageSizeHandler,
    handleSelectionReport,
    handleDownloadReport,
    handleSendReportsEmail,
    handleDeleteReports,
    reportsData,
    onSearchTextChange,
    searchText,
    setSearchText,
    isServerErrorOnList,
    isServerDataNotFoundErrorOnList,
    fileFormat,
    setShowModal,
    showModal,
    handleClose,
  };
};

export default useReportList;
